import { useGetCurrentUserInfoQuery } from "~/generated/graphql";
import { getUserID } from "../utils/loginChecks";

const useCurrentUser = () => {
  const personID = getUserID();
  const personInfoQuery = useGetCurrentUserInfoQuery({ id: personID }, { enabled: !!personID });

  return { query: personInfoQuery };
};

export default useCurrentUser;
